import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const BlogDetails = () => {
    const { slug } = useParams(); // get slug from URL
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  console.log(slug);
  

  useEffect(() => {
    const fetchBlogDetails = async () => {
      try {
        const response = await fetch(
          `https://notesmania.in/api/website_blogs.php?slug=${slug}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch blog details.");

        const data = await response.json();

        // Depending on your API structure, adjust here:
        // If API returns { data: {...blogObject...} } use:
        // const blogData = data.data;

        // If API returns blog object directly:
        const blogData = data.data || data; 

        // Parse JSON strings in blogData for tags and categories safely:
        if (blogData.tags) {
          try {
            blogData.tags = JSON.parse(blogData.tags);
          } catch {
            blogData.tags = [];
          }
        }

        if (blogData.categories) {
          try {
            blogData.categories = JSON.parse(blogData.categories);
          } catch {
            blogData.categories = [];
          }
        }

        setBlog(blogData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching blog details:", error);
        setError(error.message);
        setLoading(false);
      }
    };

    fetchBlogDetails();
  }, [slug]);

  if (loading)
    return (
      <div className="main-loading">
        <div className="spacecraft-loading">
          <span>L</span>
          <span>O</span>
          <span>A</span>
          <span>D</span>
          <span>I</span>
          <span>N</span>
          <span>G</span>
          <div className="orbit"></div>
        </div>
      </div>
    );

  if (error) return <p>Error: {error}</p>;

  if (!blog) return <p>No blog found.</p>;

  return (
    <div className="w-4/5 m-auto py-12">
      <h1 className="text-4xl font-bold mb-4">{blog.blog_name}</h1>

      {/* Thumbnail Image */}
      {blog.thumbnail_url && (
        <img
          src={`${process.env.REACT_APP_BASE_URL}/${blog.thumbnail_url}`}
          alt={blog.blog_name}
          className="w-full rounded-lg mb-6"
        />
      )}

      {/* Description HTML */}
      {blog.description_html && (
        <div
          className="text-lg text-gray-700 mb-4"
          dangerouslySetInnerHTML={{ __html: blog.description_html }}
        />
      )}

      {/* Categories */}
      {/* {blog.categories && blog.categories.length > 0 && (
        <div className="mb-4">
          <strong>Categories: </strong>
          {blog.categories.map((cat, idx) => (
            <span
              key={idx}
              className="inline-block bg-blue-600 text-white px-3 py-1 rounded mr-2 text-sm"
            >
              {cat.label}
            </span>
          ))}
        </div>
      )} */}

      {/* Tags */}
      {/* {blog.tags && blog.tags.length > 0 && (
        <div className="mb-4">
          <strong>Tags: </strong>
          {blog.tags.map((tag, idx) => (
            <span
              key={idx}
              className="inline-block bg-green-600 text-white px-3 py-1 rounded mr-2 text-sm"
            >
              {tag.label}
            </span>
          ))}
        </div>
      )} */}

      {/* Other info */}
      {blog.created_at && (
        <p className="mt-2 text-sm text-gray-500">
          Published on: {new Date(blog.created_at).toLocaleDateString()}
        </p>
      )}
    </div>
  );
};
